var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 64,
    viewBox: "0 0 40 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9496 63.115H35.0196L4.23961 33.3549V63.115H0.849609V2.44495L2.06961 1.99495C2.76961 1.80495 19.5396 -3.06505 29.1996 3.14495C32.7196 5.38495 34.9596 8.90495 35.6596 13.445C36.1096 17.025 35.3396 20.225 33.3596 22.985C28.6296 29.255 17.8696 31.815 8.90961 33.165L39.9496 63.115ZM5.06961 30.285C15.3696 28.815 26.3196 26.635 30.5996 20.945C32.1996 18.895 32.7096 16.725 32.2596 13.965C31.6796 10.315 30.1496 7.69495 27.3996 5.96495C20.0396 1.29495 6.98961 4.23495 4.22961 5.00495V30.415L5.05961 30.285H5.06961Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperR);
export default __webpack_public_path__ + "static/media/UPPER_R.2b1fe578f4bd4a18ded81d4e25a8f7df.svg";
export { ForwardRef as ReactComponent };